export const ShopExcludedForClearingCart = [
  'mrcatest2.myshopify.com',
  'everythhingisfree.myshopify.com',
  'kbrise-preprod.myshopify.com',
  'lr-eshop.myshopify.com',
  'kbd-b2b-portal.myshopify.com',
];
